/**
 * Transaction Routes
 */
/* eslint-disable */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Location } from 'Util/Location';

// async components
import { AsyncOrderListComponent, AsyncOrderDetailComponent, AsyncAccountantTransactionsListComponent } from 'Components/AsyncComponent/AsyncComponent';

const Order = props => (
  <div className="content-wrapper">
    {props.location.pathname === '/admin/transaction' && <Navigate to="transactions/list" />}
    {props.location.pathname === '/admin/transaction/transactions' && <Navigate to="transactions/list" />}
    {props.location.pathname === '/admin/transaction/order' && <Navigate to="order/list" />}
    <Routes>
      <Route path={`transactions/list`} element={<AsyncAccountantTransactionsListComponent />} />
      <Route path={`order/list`} element={<AsyncOrderListComponent />} />
      <Route path={`order/detail/:id`} element={<AsyncOrderDetailComponent />} />
    </Routes>
  </div>
);

export default Location(Order);
